import { COOKIE_NAMES, getCookie, isServerSide, LOCAL_USER_SESSION_EXPIRED_EVENT } from "@jti/fe-common";

import type { ErrorDetails } from "../../../MagentoGraphQLRequestClientError";

const EXPIRED_SESSION_ERROR_CODE = 401;
const EXPIRED_SESSION_ERROR_CATEGORY = "graphql-authorization";
const CUSTOMER_CART_ERROR_PATH = "customerCart";

const isUserLoggedIn = () => {
  const userLoggedInCookieName = COOKIE_NAMES.LOGGED_IN();

  if (!userLoggedInCookieName) {
    return false;
  }

  return getCookie(userLoggedInCookieName) === "true";
};

export const validateMagentoErrorCodes = (
  errorCodes: string[] | null = [],
  errorsDetails: ErrorDetails[] | null = []
) => {
  if (isServerSide()) {
    return;
  }

  const codes = errorCodes ?? [];
  const details = errorsDetails ?? [];
  const isExpiredSessionErrorCode = codes.some((code) => Number(code) === EXPIRED_SESSION_ERROR_CODE);
  const isLoggedInCustomerAuthorizationError =
    details.some(
      (error) =>
        error.path?.[0] === CUSTOMER_CART_ERROR_PATH && error.extensions?.category === EXPIRED_SESSION_ERROR_CATEGORY
    ) && isUserLoggedIn();

  if (isExpiredSessionErrorCode || isLoggedInCustomerAuthorizationError) {
    window.dispatchEvent(new Event(LOCAL_USER_SESSION_EXPIRED_EVENT));
  }
};
